import {ITrainingRecordDocumentSummary} from '../../message-models/training-record-document-summary.interface';
import {Observable} from 'rxjs';
import {HttpClient, HttpEvent, HttpRequest} from '@angular/common/http';
import {SettingsProviderService} from '../../common/settings-provider.service';
import {BaseApiService} from '../../common/base-api.service';
import {Router} from '@angular/router';
import {DocumentTypeService} from '../../services/document-type.service';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TrainingTypeDocumentService extends BaseApiService {
  constructor(http: HttpClient) {
    super(http, new SettingsProviderService('ecaApi'), 'TrainingRecordDocument');
  }

  getAllTrainingTypeDocumentSummaries(companyId: string, trainingTypeId?: string, includeExpired?: boolean): Observable<ITrainingRecordDocumentSummary[]> {
    return this.post<ITrainingRecordDocumentSummary[]>('GetAllTrainingTypeDocumentSummaries', {trainingTypeId: trainingTypeId, companyId: companyId, includeExpired});
  }

  getTrainingTypeDocumentSummary(documentId: string): Observable<ITrainingRecordDocumentSummary> {
    return this.post<ITrainingRecordDocumentSummary>('GetTrainingTypeDocumentSummary', {documentId});
  }

  createOrUpdateTrainingTypeDocument(TrainingTypeDocumentUpload: any): Observable<ITrainingRecordDocumentSummary> {
    return this.post<ITrainingRecordDocumentSummary>('CreateOrUpdateTrainingTypeDocument', TrainingTypeDocumentUpload);
  }

  deleteTrainingTypeDocument(documentId: string, companyId: string): Observable<ITrainingRecordDocumentSummary> {
    return this.post<ITrainingRecordDocumentSummary>('DeleteTrainingTypeDocument', {documentId, companyId});
  }
}
